import script from "./User.vue?vue&type=script&setup=true&lang=ts"
export * from "./User.vue?vue&type=script&setup=true&lang=ts"

import "./User.vue?vue&type=style&index=0&id=134f5d6b&scoped=true&lang=css"
import "./User.vue?vue&type=style&index=1&id=134f5d6b&lang=css"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134f5d6b"]])

export default __exports__